// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mudkip: PokeData = {
  "id": 258,
  "name": "mudkip",
  "height": 4,
  "weight": 76,
  "base_experience": 62,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "growl",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "surf",
    "rock-throw",
    "screech",
    "bide",
    "amnesia",
    "rock-slide",
    "protect",
    "mud-slap",
    "foresight",
    "rock-smash",
    "whirlpool",
    "endeavor",
    "mud-sport",
    "water-pulse"
  ],
  "moves": [
    "tackle",
    "growl",
    "supersonic",
    "hydro-pump",
    "rock-throw",
    "rock-slide",
    "protect",
    "mud-slap",
    "rock-smash",
    "whirlpool",
    "rain-dance",
    "life-dew",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 132,
    "item": null,
    "species": [
      {
        "name": "mudkip",
        "order": 283,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "marshtomp",
        "order": 284,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 258,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "swampert",
        "order": 285,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 259,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 40,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
